import {
  Button, // FormControlLabel,
  CircularProgress, // Switch,
  TextField,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';

import i18n from '_utils/i18n';

/* */
const styles = (theme) => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing.unit,
  },
  textField: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  submit: {
    marginTop: theme.spacing.unit * 2,
  },
});

/* */
class RegisterForm extends React.Component {
  /* */
  state = {
    checkedA: true,
  };

  /* */
  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };

  /* */
  render() {
    const { errors, values, classes, handleBlur, handleChange, handleSubmit, isSubmitting } = this.props;

    return (
      <div className='form'>
        <TextField
          required
          fullWidth
          name='email'
          type='email'
          label={i18n.t('auth.form.labels.email')}
          variant='outlined'
          onBlur={handleBlur}
          value={values.email}
          onChange={handleChange}
          error={!!errors.email}
          helperText={errors.email}
          className={classes.textField}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          required
          fullWidth
          name='password'
          type='password'
          variant='outlined'
          label={i18n.t('auth.form.labels.password')}
          onBlur={handleBlur}
          value={values.password}
          onChange={handleChange}
          error={!!errors.password}
          helperText={errors.password}
          className={classes.textField}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <Button
          fullWidth
          size='large'
          color='secondary'
          variant='contained'
          onClick={handleSubmit}
          className={classes.submit}
        >
          {isSubmitting ? <CircularProgress color='inherit' size={24} /> : i18n.t('auth.form.actions.sign_in')}
        </Button>
      </div>
    );
  }
}

export default withStyles(styles)(RegisterForm);
